import briefcase from '../images/img/icon/briefcase.png'
import calander from '../images/img/icon/CalendarBlank.png'
import mapline from '../images/img/icon/MapPinLine.png'
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';
// same jobs data ko import ya context se la sakte ho
import jobs from "../component/career component/JobsData";
import MarqueeSlider from '../component/slider/MarqueeSlider'
import JobList from '../component/career component/JobList'
import ApplyModal from '../component/career component/ApplyModal'
import Cta from '../component/Cta';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Apply = () => {
  const query = useQuery();
  const searchId = query.get("search"); 
  const job = jobs.find((j) => j.id === searchId);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);

 const openModal = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };
  if (!job) {
    return <p>Job not found.</p>;
  }

  return (
    <>
      <Helmet>
        <title>ParcelX - Apply</title>
      </Helmet>
      <section className="section01">
          <div className="container-fluid">
            <div className="col-md-11 mx-auto">
                <div className="row ">
                    <div className="col-sm-8 mb-3">
                        <p className="mb-2">{job.title}</p>
                        <div>
                            <span className="badge badge-warning">On-Site</span>{" "}
                            <span className="badge badge-primary">Full Time</span>
                        </div>
                    </div>

                    <div className="col-sm-4 mb-3 text-md-right">
                        {/* <button type="button" className="btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal">
                            Apply now <i className="fas fa-arrow-right"></i>
                        </button> */}
                        {/* <p className="f-14">
                            Job Posted on <span className="fw-500 ml-3">13/2/2025</span>
                        </p> */}
                    </div>
                </div>
                <ApplyModal />
                <div className="row">
                    <div className="col-xl-8">
                        <p className="fw-500">Job Description</p>
                        <p className="f-16 mb-16">{job.Job_Description}</p>

                        <p className="fw-500">Responsibilities</p>
                        <ul>
                        {job.Responsibilities.map((res, i) => (
                            <li key={i}>{res}</li>
                        ))}
                        </ul>
                    </div>
                    <div className="col-xl-4">
                        <div className="box-content">
                        <p className="fw-500">Job Overview</p>
                        <div className="row">
                            <div className="col-xl-4 col mb-16">
                            <img src={briefcase} alt="" />
                            <p className="f-12 mb-0 mt-2">EXPERIENCE</p>
                            <p className="f-14 fw-500">{job.experience}</p>
                            </div>
                            <div className="col-xl-4 col mb-16">
                            <img src={mapline} alt="" />
                            <p className="f-12 mb-0 mt-2">LOCATION:</p>
                            <p className="f-14 fw-500">{job.location.replace("Up", "UP")}</p>
                            </div>
                            <div className="col-xl-4 col mb-16">
                            <img src={calander} alt="" />
                            <p className="f-12 mb-0 mt-2">JOB TYPE:</p>
                            <p className="f-14 fw-500">{job.type}</p>
                            </div>
                        </div>

                        <p className="fw-500">Skills Required</p>
                        <div>
                            {job.skills.map((s, i) => (
                            <div key={i} className="badge badge-secondary">
                                {s}
                            </div>
                            ))}
                        </div>
                        </div>
                    </div>
                </div>
                <ApplyModal job={job} />
            </div>
          </div>
      </section>
      <MarqueeSlider />
      <section className="slice pb-0" id="current">
        <div className="container-fluid">
          <div className="">
            <div className="col-md-11 mx-auto">
              <div className="main-heading"><span>Current Openings: </span>Be the part of our family</div>
              <JobList />
            </div>
          </div>
        </div>
      </section>
      {/* <section className="slice">
        <div className="container-fluid">
          <div className="">
            <div className="col-md-11 mx-auto">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="main-heading mb-3">Stay Informed with Our Newsletter</div>
                  <p className="f-16 color-80">Stay connected and receive the latest updates, stories, and exclusive content directly to your inbox.</p>
                  <div className="d-flex align-items-center">
                    <img src="assets/img/testiominal-img.png" className="img-fluid" alt="" />
                    <p className="mb-0 ml-2">+22k have already suscribed.</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <form action="" id="Enquire-userr">
                      <input type="text" id="form-name" placeholder="Your name" className="form-control mb-4" required />
                      <input type="text" id="form-email" required pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"  placeholder="Your Email" className="form-control mb-4" />
                      <button type="submit" id="form-submited" className="btn btn-primary w-100">Subscribe</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Cta />
    </>
  );
};

export default Apply;
